import { render, staticRenderFns } from "./BusinessProfileCdcReportResult.vue?vue&type=template&id=6347df82&scoped=true&"
import script from "./BusinessProfileCdcReportResult.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileCdcReportResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347df82",
  null
  
)

export default component.exports